import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { TextField, Button, Typography, Grid, IconButton, Box, } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { useDispatch, useSelector } from "react-redux";
import { profileAction, logoutAction, updateProfileAction, clearupdateProfileAction } from "../../store/actions";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const Profile = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isEditing, setIsEditing] = useState(false);

    const userDetails = JSON.parse(localStorage.getItem('userDetails'));

    const { successData: profileData } = useSelector((state) => state.profileReducer);
    const { successData: logoutSuccessData } = useSelector((state) => state.logoutReducer);
    const { successData: updateSuccessData, error: updateErrorData, } = useSelector((state) => state.updateProfileReducer);

    const formik = useFormik({
        initialValues: {
            fullName: "",
            email: "",
            phoneNumber: "",
        },
        validationSchema: Yup.object({
            fullName: Yup.string().required("Full Name is required"),
            email: Yup.string()
                .email("Invalid email address")
                .required("Email is required"),
            phoneNumber: Yup.string()
                .matches(/^[6-9]\d{9}$/, "Invalid phone number")
                .required("Phone Number is required"),
        }),
        onSubmit: (values) => {
            dispatch(updateProfileAction({
                endPoint: `users/profile?user_id=${userDetails?.user_id}`,
                full_name: values.fullName,
                email: values.email,
                mobile_no: values.phoneNumber,
            }));
            setIsEditing(false);
        },
    });

    useEffect(() => {
        const userDetails = JSON.parse(localStorage.getItem("userDetails"));
        dispatch(
            profileAction({
                endPoint: `users/profile?user_id=${userDetails.user_id}`,
            })
        );
    }, [dispatch]);

    useEffect(() => {
        if (profileData) {
            formik.setValues({
                fullName: profileData.data.full_name,
                email: profileData.data.email,
                phoneNumber: profileData.data.mobile_no,
            });
        }
    }, [profileData]);

    const handleLogout = () => {
        dispatch(logoutAction())
    }

    useEffect(() => {
        if (logoutSuccessData) {
            navigate("/");
            localStorage.clear();
            toast.success("Logged out successfully");
        }
    }, [logoutSuccessData])

    useEffect(() => {
        if (updateSuccessData) {
            toast.success("Profile updated successfully");
            const userDetails = JSON.parse(localStorage.getItem('userDetails'));
            dispatch(profileAction({
                endPoint: `users/profile?user_id=${userDetails?.user_id}`,
            }));
            setIsEditing(false);
        }
        if (updateErrorData) {
            toast.error(updateErrorData?.message || "Failed to update profile");
        }
        return () => {
            dispatch(clearupdateProfileAction());
        };
    }, [updateSuccessData, updateErrorData, dispatch]);

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                marginTop: {xs:"25%",sm:"15%",md:"10%"},
                marginLeft: { xs: "10px", md: "20%" },
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <Box
                sx={{
                    maxWidth: "600px",
                    width: { xs: "90%", md: "100%" },
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <Typography variant="h6" sx={{ fontWeight: "bold", color: '#007BFF' }}>
                            PROFILE
                        </Typography>
                    </Box>
                    <IconButton onClick={() => setIsEditing(!isEditing)}>
                        <EditIcon />
                    </IconButton>
                </Box>
                <form
                    onSubmit={formik.handleSubmit}
                    style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}
                >
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={10}>
                            <TextField
                                margin="dense"
                                id="fullName"
                                name="fullName"
                                label="Full Name"
                                type="text"
                                variant="outlined"
                                size="small"
                                fullWidth
                                style={{ flex: "1 1 100%" }}
                                value={formik.values.fullName}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.fullName && Boolean(formik.errors.fullName)}
                                helperText={formik.touched.fullName && formik.errors.fullName}
                                disabled={!isEditing}
                            />
                        </Grid>
                        <Grid item xs={12} sm={10}>
                            <TextField
                                margin="dense"
                                id="email"
                                name="email"
                                label="Email"
                                type="email"
                                variant="outlined"
                                size="small"
                                fullWidth
                                style={{ flex: "1 1 100%" }}
                                value={formik.values.email}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.email && Boolean(formik.errors.email)}
                                helperText={formik.touched.email && formik.errors.email}
                                disabled={!isEditing}
                            />
                        </Grid>
                        <Grid item xs={12} sm={10}>
                            <TextField
                                margin="dense"
                                id="phoneNumber"
                                name="phoneNumber"
                                label="Phone Number"
                                type="text"
                                variant="outlined"
                                size="small"
                                fullWidth
                                style={{ flex: "1 1 100%" }}
                                value={formik.values.phoneNumber}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                    formik.touched.phoneNumber && Boolean(formik.errors.phoneNumber)
                                }
                                helperText={formik.touched.phoneNumber && formik.errors.phoneNumber}
                                disabled={!isEditing}
                            />
                        </Grid>
                    </Grid>
                    {isEditing && (
                        <Button
                            type="submit"
                            variant="contained"
                            backgroundColor="#007BFF"
                            style={{ margin: "20px auto" }}
                        >
                            Save Profile
                        </Button>
                    )}
                </form>
                <Box sx={{ display: "flex", alignContent: 'right', justifyContent: 'right' }}>
                    <Button
                        type="submit"
                        sx={{
                            backgroundColor: "#007BFF",
                            color: "#fff",
                            width: "50px",
                            mt: 4,
                            mb: 4,
                        }}
                        onClick={handleLogout}
                    >
                        Logout
                    </Button>{" "}
                </Box>
            </Box>
        </Box>
    );
};

export default Profile;